import React from "react";

export default function Logo({ size = 28 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            aria-hidden="true"
            className="shrink-0"
        >
            <circle cx="32" cy="32" r="17" stroke="#F59E0B" strokeWidth="3" />
            <circle cx="32" cy="32" r="7" fill="#F59E0B" />
            <line x1="32" y1="4" x2="32" y2="13" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
            <line x1="32" y1="51" x2="32" y2="60" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
            <line x1="4" y1="32" x2="13" y2="32" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
            <line x1="51" y1="32" x2="60" y2="32" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
        </svg>
    );
}
